import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ModuleManager } from 'src/shared/models/module-manager';
import { ModuleManagerRefreshType } from 'src/shared/models/module-manager/module-manager-options.model';
import { MyRankingService } from '../my-ranking/my-ranking.service';
import { ErrorList, MyRankingData, MyRankingProfile } from '../my-ranking/my-ranking.model';
import { WidgetSize } from './cxone-my-ranking.model';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import OverlayScrollbars from 'overlayscrollbars';

@Component({
    selector: 'cxone-my-ranking',
    templateUrl: './cxone-my-ranking.component.html',
    styleUrl: './cxone-my-ranking.component.scss'
})
export class CxoneMyRankingComponent implements OnInit {

    @Input() moduleManager: ModuleManager;
    @Input() moduleKey: string;
    @ViewChild('myRankingContainer') myRankingContainer: ElementRef;

    profileData: MyRankingProfile = null;
    data: MyRankingData[] = null;
    isDataLoading = false;
    isFirstLoad = true;
    noData = true;
    noMetric = false;
    widgetSize: WidgetSize = WidgetSize.Small;
    WidgetSize = WidgetSize;
    private resizeObserver: ResizeObserver;

    constructor(
        private service: MyRankingService,
        private localizationService: CVLocalizationService
    ) { }

    scrollOptions: OverlayScrollbars.PartialOptions = {
        scrollbars: {
            autoHide: "leave",
            autoHideDelay: 100,
            theme: "scrollbar-my-ranking",
        },
    };

    ngOnInit(): void {
        this.localizationService.GetSection("My_Ranking");
        this.moduleManager.setOptions({
            enableWidthClass: false,
            widgetMode: false,
            onSettingsApplied: () => this.loadData(false),
            hasRefresh: true,
            refreshType: ModuleManagerRefreshType.FiveMinute,
            onRefresh: isAutoRefresh => {
                if (!isAutoRefresh)
                    this.moduleManager.showLoader = true;
                this.loadData(isAutoRefresh);

            },
            canRefresh: () => !this.isDataLoading,
        });
        this.resizeObserver = new ResizeObserver(entries => {
            for (const entry of entries) {
                const widgetWidth = entry.contentRect.width;
                if (widgetWidth >= 790) {
                    this.widgetSize = WidgetSize.Large;
                } else if (widgetWidth >= 535) {
                    this.widgetSize = WidgetSize.Medium;
                }else {
                    this.widgetSize = WidgetSize.Small;
                }
            }
        });
        this.resizeObserver.observe(this.myRankingContainer.nativeElement);
    }

    ngOnDestroy(): void {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }

    private async loadData(isAutoRefresh) {
        // Return if data is currently loading
        if (this.isDataLoading) {
            return;
        }

        this.isDataLoading = true;
        if (!isAutoRefresh) {
            this.moduleManager.showLoader = true;
        }

        // Data load
        try {
            const response = await this.service.loadData(this.moduleKey, isAutoRefresh);
            this.profileData = response.profile;
            this.data = response.data;
            this.noData = !this.data;
            this.noMetric = response.error == ErrorList.NoMetric;

            if(!this.noMetric){
                this.moduleManager.container.showDateRange = true;
            }

        } catch (err) {
            this.moduleManager.handleLoadError(err, isAutoRefresh);
        } finally {
            this.moduleManager.showLoader = false;
            this.isDataLoading = false;
            this.isFirstLoad = false;
        }
    }
}
